import { createSlice } from '@reduxjs/toolkit';

import {
    DELETE_DATASHEET,
    DELETE_DATASHEET_FAILURE,
    DELETE_DATASHEET_SUCCESS,
    DOWNLOAD_DATASHEET,
    DOWNLOAD_DATASHEET_FAILURE,
    DOWNLOAD_DATASHEET_SUCCESS,
    FETCH_PRODUCT_DATASHEET,
    FETCH_PRODUCT_DATASHEET_FAILURE,
    FETCH_PRODUCT_DATASHEET_SUCCESS,
    RESET,
    RESET_UPLOAD_MODEL,
    SHOW_FORM,
    UPLOAD_DATASHEET,
    UPLOAD_DATASHEET_FAILURE,
    UPLOAD_DATASHEET_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    dataConfirmModal: {
        message: '',
        title: null,
        variant: '',
    },
    deleteDatasheet: {
        error: null,
        isLoading: false,
    },
    downloadDatasheet: {
        data: null,
        errors: [],
        isFetching: false,
    },
    elementToDelete: null,
    initialValues: {
        archive: null,
        id: null,
        name: null,
        productId: null,
        productType: null,
    },
    isOpenConfirmModal: null,
    isVisibleForm: false,
    productDatasheet: {
        data: null,
        error: null,
        isLoading: false,
    },
    uploadDatasheet: {
        errors: null,
        isLoading: false,
    },
};

const productDatasheetsSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [DELETE_DATASHEET]: (state) => {
            state.deleteDatasheet.isLoading = true;
        },
        [DELETE_DATASHEET_FAILURE]: (state, action) => {
            state.deleteDatasheet = {
                ...state.deleteDatasheet,
                error: action.payload,
                isLoading: false,
            };
        },
        [DELETE_DATASHEET_SUCCESS]: (state) => {
            state.deleteDatasheet.isLoading = false;
        },
        [DOWNLOAD_DATASHEET]: (state) => {
            state.downloadDatasheet = {
                ...state.downloadDatasheet,
                errors: [],
                isFetching: true,
            };
        },
        [DOWNLOAD_DATASHEET_FAILURE]: (state, action) => {
            state.downloadDatasheet = {
                ...state.downloadDatasheet,
                errors: action.payload,
                isFetching: false,
            };
        },
        [DOWNLOAD_DATASHEET_SUCCESS]: (state, action) => {
            state.downloadDatasheet = {
                ...state.downloadDatasheet,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PRODUCT_DATASHEET]: (state) => {
            state.productDatasheet.isLoading = true;
        },
        [FETCH_PRODUCT_DATASHEET_FAILURE]: (state, action) => {
            state.productDatasheet = {
                ...state.productDatasheet,
                error: action.payload,
                isLoading: false,
            };
        },
        [FETCH_PRODUCT_DATASHEET_SUCCESS]: (state, action) => {
            state.productDatasheet = {
                ...state.productDatasheet,
                data: action.payload,
                error: null,
                isLoading: false,
            };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_UPLOAD_MODEL]: (state) => {
            state.uploadDatasheet = {
                ...state.uploadDatasheet,
                errors: null,
                isLoading: false,
            };
        },
        [SHOW_FORM]: (state, action) => {
            state.isVisibleForm = action.payload;
        },
        [UPLOAD_DATASHEET]: (state) => {
            state.uploadDatasheet.isLoading = true;
        },
        [UPLOAD_DATASHEET_FAILURE]: (state, action) => {
            state.uploadDatasheet = {
                ...state.uploadDatasheet,
                errors: action.payload,
                isLoading: false,
            };
        },
        [UPLOAD_DATASHEET_SUCCESS]: (state) => {
            state.uploadDatasheet.isLoading = false;
        },
    },
});

export const productDatasheetsActions = productDatasheetsSlice.actions;

export default productDatasheetsSlice.reducer;
